import script from "./SheetSong.vue?vue&type=script&lang=ts&setup=true"
export * from "./SheetSong.vue?vue&type=script&lang=ts&setup=true"

import "./SheetSong.vue?vue&type=style&index=0&id=f4f8e4e0&lang=scss&scoped=true"
script.__scopeId = "data-v-f4f8e4e0"

export default script